import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from 'app/core/auth/authentication.service';
import { Role } from 'app/core/auth/enums/role.enum';
import { ChatService } from 'app/store/chat/chat.service';
import { MenuItem } from './model/menu-item';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
})
export class MenuComponent {
  private _menuItems = [
    new MenuItem('Companies', '/companies', 'assets/img/sidebar-menu/product-icon.svg'),
    new MenuItem('Messages', '/chat', 'assets/img/sidebar-menu/message-icon.svg'),
    new MenuItem('Alerts', '/alerts', 'assets/img/sidebar-menu/notifications-icon.svg'),
    new MenuItem('Analytics', '/analytics', 'assets/img/sidebar-menu/analytics-icon.svg'),
    new MenuItem('Users', '/physician-users', 'assets/img/sidebar-menu/physician-users-icon.svg'),
    new MenuItem('News', '/news-administration', 'assets/img/sidebar-menu/news-icon.svg'),
    new MenuItem('Products', '/company-products', 'assets/img/sidebar-menu/product-icon.svg'),
    new MenuItem('Members', '/company-users', 'assets/img/sidebar-menu/member-icon.svg'),
    new MenuItem('Territories', '/teritories', 'assets/img/sidebar-menu/teritories-icon.svg'),
  ];

  private _adminMenu = ['Companies', 'Messages', 'Alerts', 'Analytics', 'Users', 'News'];

  private _companyAdminMenu = ['Products', 'Messages', 'Alerts', 'Analytics', 'Members', 'Territories'];

  private _salesRepMenu = ['Messages', 'Territories'];

  private _mslMenu = ['Messages', 'Territories'];

  private _patientAssistance = ['Messages', 'Territories'];

  constructor(private _authService: AuthenticationService, private _chatService: ChatService) {}

  logout() {
    this._authService.logout();
  }

  get unreadMessaages() {
    return this._chatService.channelsData.totalNumberOfUnreadMessaages;
  }

  get menu() {
    if (!this._authService.currentUser) {
      return [];
    }
    if (this._authService.currentUser.role === Role.ADMIN) {
      return this.getMenuItems(this._adminMenu);
    }
    if (this._authService.currentUser.role === Role.COMPANY_ADMIN) {
      return this.getMenuItems(this._companyAdminMenu);
    }
    if (this._authService.currentUser.role === Role.MSL) {
      return this.getMenuItems(this._mslMenu);
    }
    if (this._authService.currentUser.role === Role.SALES_REP) {
      return this.getMenuItems(this._salesRepMenu);
    }
    if (this._authService.currentUser.role === Role.PATIENT_ASSISTANCE) {
      return this.getMenuItems(this._patientAssistance);
    }
    return [];
  }

  private getMenuItems(list: string[]) {
    return list.map((i) => this._menuItems.find((menuItem) => menuItem.label === i));
  }
}
